import React from "react";
import { data } from "../../Assets/js/data";
import { Link } from "react-router-dom";

const Commissions = () => {
  return (
    <div id="commissions" className="page">
      <h1 className="page-title">COMMISSIONS</h1>
      <div className="commissions-images">
        {data.commissions.map(commission => {
          return (
            <Commission key={commission.title} commission={{ ...commission }} />
          );
        })}
      </div>
    </div>
  );
};

const Commission = commission => {
  return (
    <Link
      className="commission-item"
      style={{
        backgroundImage: `url(${commission.commission.thumb})`
      }}
      to={`commissions/${commission.commission.link}`}
    >
      <h2>{commission.commission.title}</h2>
    </Link>
  );
};

export default Commissions;
